// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.controls {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: var(--spacing);
  border: var(--border-size) var(--border-style) var(--border-color);
  padding: var(--spacing);
  border-radius: var(--box-rounding);
  background-color: var(--background-alt);
  box-shadow: var(--box-shadow);
  transition: var(--transition);
}

.input-section {
  display: flex;
  gap: var(--spacing);
}

.input-section-grid {
  display: flex;
  gap: var(--spacing-less);
}

.input-group {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.input-group label {
  margin-bottom: var(--spacing-less);
  width: max-content;
}

.input-group input {
  height: var(--input-xs);
}

.input-group input[type='file'] {
  max-width: var(--input-xl);
}

.input-group input[type='number'] {
  width: var(--input-sm);
}

@media (max-width: 600px) {
  .controls {
    flex-direction: column;
  }

  .input-group label {
    align-self: center;
  }

  .input-group input {
    align-self: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ArtGrid/Controls/Controls.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,kEAAkE;EAClE,uBAAuB;EACvB,kCAAkC;EAClC,uCAAuC;EACvC,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".controls {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  gap: var(--spacing);\n  border: var(--border-size) var(--border-style) var(--border-color);\n  padding: var(--spacing);\n  border-radius: var(--box-rounding);\n  background-color: var(--background-alt);\n  box-shadow: var(--box-shadow);\n  transition: var(--transition);\n}\n\n.input-section {\n  display: flex;\n  gap: var(--spacing);\n}\n\n.input-section-grid {\n  display: flex;\n  gap: var(--spacing-less);\n}\n\n.input-group {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.input-group label {\n  margin-bottom: var(--spacing-less);\n  width: max-content;\n}\n\n.input-group input {\n  height: var(--input-xs);\n}\n\n.input-group input[type='file'] {\n  max-width: var(--input-xl);\n}\n\n.input-group input[type='number'] {\n  width: var(--input-sm);\n}\n\n@media (max-width: 600px) {\n  .controls {\n    flex-direction: column;\n  }\n\n  .input-group label {\n    align-self: center;\n  }\n\n  .input-group input {\n    align-self: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
